var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Network signal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Network-signal",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 3.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "18.015 26 13.3333333 10 8.65166667 26 15.9716667 19.0166667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8.65166667 26 13.3333333 10 18.015 26 10.6933333 19.0216667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1666667,6.10333333 C9.21445124,7.05541371 8.67949083,8.34679286 8.67949083,9.69333333 C8.67949083,11.0398738 9.21445124,12.331253 10.1666667,13.2833333 L10.1666667,13.2833333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22333333,3.53666667 C5.58885601,5.16636471 4.6689682,7.37877102 4.66614847,9.68689232 C4.66334169,11.9950136 5.57783358,14.2096558 7.20833333,15.8433333 L7.22333333,15.8583333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28833333,0.97 C-0.531616458,5.78274924 -0.537585922,13.5915538 4.275,18.4116667 L4.28833333,18.425",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5083333,6.10333333 C17.4605488,7.05541371 17.9955092,8.34679286 17.9955092,9.69333333 C17.9955092,11.0398738 17.4605488,12.331253 16.5083333,13.2833333 L16.5083333,13.2833333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4433333,3.53666667 C21.0778107,5.16636471 21.9976985,7.37877102 22.0005182,9.68689232 C22.003325,11.9950136 21.0888331,14.2096558 19.4583333,15.8433333 L19.4433333,15.8583333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3783333,0.97 C27.1982831,5.78274924 27.2042526,13.5915538 22.3916667,18.4116667 L22.3783333,18.425",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkSignal);
export default __webpack_public_path__ + "static/media/network-signal.77c0c8c9977cfc106428a533569e0f0c.svg";
export { ForwardRef as ReactComponent };